import { motion } from "framer-motion";
import { Phone, CalendarCheck, ArrowUpRight } from "lucide-react";
import { PHONE, MERO_URL } from "../../data/site";

export const CtaCall = () => {
    return (
        <section
            id="programari"
            data-testid="cta-section"
            className="relative overflow-hidden bg-gold py-24 text-black md:py-32"
        >
            <div className="mx-auto max-w-5xl px-6 text-center md:px-12">
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="kicker text-black/60"
                >
                    Programează-te acum
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-6 font-display text-4xl font-semibold leading-[0.95] tracking-tight sm:text-6xl lg:text-8xl"
                >
                    Sună acum și <br /> rezervă-ți locul
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="mx-auto mt-6 max-w-xl font-body text-lg text-black/70"
                >
                    Programează-te rapid printr-un simplu apel — îți găsim ora
                    perfectă. Preferi online? Rezervă în câteva secunde pe MERO.
                </motion.p>

                <motion.a
                    data-testid="cta-call-btn"
                    href={`tel:${PHONE.raw}`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.25 }}
                    className="mt-12 inline-flex items-center gap-3 whitespace-nowrap rounded-full bg-black px-7 py-5 font-display text-lg font-medium text-white transition-transform duration-300 hover:scale-[0.97] sm:gap-4 sm:px-10 sm:py-6 sm:text-xl"
                >
                    <Phone size={22} strokeWidth={2} className="text-gold" />
                    {PHONE.display}
                </motion.a>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.35 }}
                    className="mt-6"
                >
                    <a
                        data-testid="cta-mero-btn"
                        href={MERO_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center gap-2 font-body text-sm font-medium text-black/70 transition-colors duration-300 hover:text-black"
                    >
                        <CalendarCheck size={17} strokeWidth={1.75} />
                        <span className="border-b border-black/30 pb-0.5 transition-colors duration-300 group-hover:border-black">
                            Sau rezervă online pe MERO
                        </span>
                        <ArrowUpRight
                            size={15}
                            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                        />
                    </a>
                </motion.div>
            </div>
        </section>
    );
};
